export default __webpack_public_path__ + "static/media/nft-17.b354dc4a.png";